// extracted by mini-css-extract-plugin
module.exports = {"Disclaimer":"Disclaimer_Disclaimer__ljM1G"};